import { monitorRequest } from '../monitoring/request';
import { HttpClient } from '@wix/http-client';

export const createMetaSiteByTemplate = async (
  baseUrl: string,
  originTemplateId: string,
): Promise<string> => {
  const httpClient = new HttpClient({ baseURL: baseUrl });
  return monitorRequest('create-metasite', async () => {
    const { data } = await httpClient.post<{ metaSiteId: string }>(
      '/api/create-metasite',
      { originTemplateId },
    );

    if (!data.metaSiteId) {
      throw new Error('Site creation returned no metaSiteId');
    }
    return data.metaSiteId;
  });
};
